import classnames from 'classnames';
import React, { useState, type FC } from 'react';

import { Image } from '@/domains/core/Image/Image';
import type { MediaType } from '@/domains/productDiscovery/ProductPage/interfaces/fromApi/msfProductPage.model';

import { VideoEmbed } from '../VideoEmbed/VideoEmbed';

import styles from './Slide.module.scss';

interface Props {
  mediaURL: string;
  zoomUrl: string;
  alt: string;
  loading: 'lazy' | 'eager';
  type: MediaType;
  regularUrl?: string;
  isVisible?: boolean;
  fetchPriority?: 'auto' | 'high' | 'low';
}

export const Slide: FC<Props> = ({
  loading,
  mediaURL,
  alt,
  zoomUrl,
  type,
  regularUrl,
  isVisible,
  fetchPriority,
}) => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);

  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPosition, setZoomPosition] = useState(`50% 50%`);

  const onMouseOver = () => {
    setIsZoomed(true);
  };
  const onMouseOut = () => {
    setIsZoomed(false);
  };
  const onMouseMove = (event: React.MouseEvent) => {
    if (containerRef.current) {
      const { left, top, width, height } =
        containerRef.current.getBoundingClientRect();
      const x = ((event.clientX - left) / width) * 100;
      const y = ((event.clientY - top) / height) * 100;
      setZoomPosition(`${x}% ${y}%`);
    }
  };

  if (!type) return null;

  const isImage = type === 'image';

  return (
    <div
      className={classnames(styles.slide, styles.gallery)}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onMouseMove={onMouseMove}
      onFocus={onMouseOver}
      onBlur={onMouseOut}
      ref={containerRef}
      style={{
        backgroundImage: isZoomed && isImage ? `url(${zoomUrl})` : undefined,
        backgroundPosition: zoomPosition,
      }}
    >
      {isImage ? (
        <Image
          src={mediaURL}
          height="470"
          width="470"
          loading={loading}
          alt={alt}
          fetchpriority={fetchPriority}
        />
      ) : (
        regularUrl && (
          <VideoEmbed
            className={styles.gallery}
            url={isVisible ? regularUrl : ''}
            title="video"
          />
        )
      )}
    </div>
  );
};

Slide.displayName = 'Slide';
